/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [

  // Mandala Design

  {
    _id: "mnpLhfEDnrc",
    title: "SIMPLE Dot Mandala Painting",
    categoryName: "Mandala Designs",
    creator: "Lydia May",
    views: "1.35M",
    duration: "16:02",
    createdDate: "Jan 2, 2022",
    description: "In this tutorial, I will give you step by step instructions for this wonderfully relaxing & fun project.Follow along and paint this gorgeous pink to blue gradient dot art mandala design, using dotting tools on a 6 wood craft circle"
  },
  {
    _id: "mTW_tEEVzvw",
    title: "Dot mandala painting with a mirror on MDF board. Mirror wall decoration with dot painting tutorial.",
    categoryName: "Mandala Designs",
    creator: "Kraftaria by Sarika",
    views: "23k",
    duration: "12:09",
    createdDate: "Jan 2, 2022",
    description: "In this tutorial, I will give you step by step instructions for this wonderfully relaxing & fun project.Follow along and paint this gorgeous pink to blue gradient dot art mandala design, using dotting tools on a 6 wood craft circle"
  },

  {
    _id: "ryH2L3XhCKc",
    title: "Mandala art using cone and dotting tools",
    categoryName: "Mandala Designs",
    creator: "SHWETAART03",
    views: "85k",
    duration: "25:02",
    createdDate: "Feb 16, 2019",
    description: `Material used and their links:
    For Indians:
    Flash acrylic American gold paint: https://amzn.to/2V208jg
    Flash acrylic gold plus paint: https://amzn.to/2IknFL0
    Flash acrylic blue paint: https://amzn.to/2TOk5Kd
    Dotting tools:
    1) Nail stylus: https://amzn.to/2IgKOOy
    2) Bamboo crochet hooks: https://amzn.to/2TTn6cy
    Transparent plastic wrap for cone: https://amzn.to/2TMsKwV
    Rhinestones:  https://amzn.to/2V1GBzN
    Canvas Board- https://amzn.to/2Lwgr9d`
  },
  //Macrame

  {
    _id: "aOUfbkRN-i0",
    title: "DIY Macrame Wall Hanging Leaves with Flower",
    categoryName: "Macrame",
    creator: "Macrame School",
    views: "173k",
    duration: "10:55",
    createdDate: "Mar 24, 2021",
    description: `Macrame leaves wall hanging with flower. DIY Colorful wall decor in Boho style - Tapiz de Macramé.

    Materials: 5mm thick Braided Coton cord:
    Row 1 - 6 x 450cm (177 inch)
    Row 2 - 6 x 350cm (138 inch)
    Row 3 - 6 x 250cm (99 inch)
    Approximate dimensions: 38 x 38cm (15 x 15 inch)`
  },
  {
    _id: "5xUM7O9mkdc",
    title: "Macrame Flower Wall hanging",
    categoryName: "Macrame",
    creator: "Macrame Creation",
    views: "32k",
    duration: "14:27",
    createdDate: "Apr 6, 2021",
    description: `Pink macrame - 26 cords of 1 meter
    Blue macrame -1 cord of 5 meter approx.
green beats - 21 (flower beats)
Ring - 8 inch
____
Pink macrame -  24 cords of 1 meter
Blue macrame - 12 cords of 1 meter
mataka beats (green)-  30approx.
Ring - 4 inch
Red Bells - 24 approx.`
  },
  {
    _id: "Y4yf7j0fVto",
    title: "DIY Macrame Mirror step by step",
    categoryName: "Macrame",
    creator: "Rox Shana",
    views: "1.84M",
    duration: "12:00",
    createdDate: "Oct 10, 2020",
    description: `In this video I show you how to make a Macrame Mirror step by step.`
  },
  {
    _id: "smcPku4h-ro",
    title: "Mini macrame tutorial for beginners / DIY Macrame ornaments / Mini macrame Wall Hanging",
    categoryName: "Macrame",
    creator: "Supriya's Craft Idea",
    views: "32k",
    duration: "8:14",
    createdDate: "Nov 18, 2021",
    description: `The Easiest Macrame wall hanging you can make / DIY Macrame ornaments / Mini macrame Wall Hanging ||

    9 pics cord 130 cm...`
  },
  {
    _id: "UoUeZv4NDZw",
    title: "How to make DIY Macrame jumar! Make Macrame wall hanging craft!",
    categoryName: "Macrame",
    creator: "Ap Craft",
    views: "25k",
    duration: "17:53",
    createdDate: "Feb 24, 2021",
    description: `How to make DIY Macrame jumar! Make Macrame wall hanging craft! Make wall hanging at home! DIY JUMAR
    1. how to make jumar at home
    2. make beautiful wall hanging craft at home
    3. make macrame wall hanging for home decoration
    4. Home decoration ideas for festival
    5. macrame thread jumar making ideas
    6. ghar par jumar banane ka tarika
    7. moti se ghar par jumar kaise banaye
    unique wall hanging ideas`
  },

  // dreamcatcher

  {
    _id: "Vmtkc7FOWLw",
    title: "DIY Dreamcatcher | How To Make A Dream Catcher Tutorial",
    categoryName: "DreamCatcher",
    creator: "Emilie Lefler",
    views: "2.5M",
    duration: "12:35",
    createdDate: "Feb 5, 2015",
    description: "This dreamcatcher tutorial is for beginners. So don't worry if you've never made one before this beginner dreamcatcher tutorial will get you started."
  },
  {
    _id: "e1j88mXZ7QA",
    title: "DREAMCATCHER DIY Tutorial | MAKE THIS 5 MINUTES!!! |",
    categoryName: "DreamCatcher",
    creator: "Fayza Patekari",
    views: "83k",
    duration: "11:44",
    createdDate: "Jun 30, 2020",
    description: "This dreamcatcher tutorial is for beginners. So don't worry if you've never made one before this beginner dreamcatcher tutorial will get you started."
  },
  {
    _id: "yu2usryLrf8",
    title: "Diy Dream Catcher|| Easy Dream Catcher webbing tutorial|",
    categoryName: "DreamCatcher",
    creator: "Handmade Bliss",
    views: "1M",
    duration: "4:03",
    createdDate: "Mar 11, 2019",
    description: "This dreamcatcher tutorial is for beginners. So don't worry if you've never made one before this beginner dreamcatcher tutorial will get you started."
  },
  {
    _id: "EqwWTUDLOhs",
    title: "DIY Macrame Wall Hanging Dream Catcher | Wall Hanging Craft Ideas Home Decor",
    categoryName: "DreamCatcher",
    creator: "Globe Studio One",
    views: "1.5M",
    duration: "12:43",
    createdDate: "Oct 15, 2019",
    description: "This dreamcatcher tutorial is for beginners. So don't worry if you've never made one before this beginner dreamcatcher tutorial will get you started."
  },
  //decoration
  {
    _id: "CKxW8jTQx2U",
    title: "Peacock Wall Hanging",
    categoryName: "Decoration",
    creator: "Craft Campus",
    views: "1.3M",
    duration: "6:34",
    createdDate: "Sep 20, 2021",
    description: "Peacock Wall Hanging | Woolen Peacock Wall Hanging | DIY Easy Woolen Peacock Wall Hanging"
  },
  {
    _id: "GSWGPYkD5Hg",
    title: "DIY Beautiful Wall Hanging || Room Decor Idea || Easy Paper Craft",
    categoryName: "Decoration",
    creator: "DP art idea",
    views: "3.85M",
    duration: "3:47",
    createdDate: "May 29, 2021",
    description: "DIY Beautiful Wall Hanging || Room Decor Idea || Easy Paper Craft"
  },
  {
    _id: "pqh_ry8Vuso",
    title: "Unique Wall Hanging Craft using Earbuds | Home Decoration Ideas",
    categoryName: "Decoration",
    creator: "RB creative world ",
    views: "83k",
    duration: "5:30",
    createdDate: "Mar 4, 2022",
    description: "Unique Wall Hanging Craft using Earbuds | Home Decoration Ideas"
  },
];
